export const legalDisclaimerTextFirstLine =
  "*אישור ההלוואה ותנאי העמדתה הינם בהתאם לתנאי ולמדיניות החברה ובכפוף לשיקול דעתה הבלעדי.";
export const legalDisclaimerTextSecondLine =
  "אי עמידה בפירעון ההלוואה או בהחזר האשראי עלולה לגרור חיוב בריבית פיגורים והליכי הוצאה לפועל.";
